/*!
  Atom, by Koding Themes
  predictive-search.js
  https://kodingthemes.com
*/

class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');
		this.input.addEventListener('input', this.debounce((event) => {
			this.onChange(event);
		}, 300).bind(this));
		this.input.addEventListener('focus', this.debounce((event) => {
			this.onFocus(event);
		}, 0).bind(this));
	}
	onChange() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			return;
		}
		this.getSearchResults(searchTerm);
	}
	onFocus() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			return;
		}
		this.getSearchResults(searchTerm);
	}
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`).then((response) => {
			if (!response.ok) {
				var error = new Error(response.status);
				this.close();
				throw error;
			}
			return response.text();
		}).then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(
				'#shopify-section-predictive-search').innerHTML;
			this.predictiveSearchResults.innerHTML = resultsMarkup;
			this.open();
		}).catch((error) => {
			this.close();
			throw error;
		});
	}
	open() {
		this.predictiveSearchResults.style.display = 'block';
	}
	close() {
		this.predictiveSearchResults.style.display = 'none';
		this.predictiveSearchResults.innerHTML = '';
	}
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}
customElements.define('predictive-search', PredictiveSearch);
var forms = document.querySelectorAll('predictive-search');
document.body.addEventListener('click', function(e) {
	var target = e.target;
	var clickedForm = target.closest('predictive-search');

	forms.forEach(function(form) {
		var list = form.querySelector('.search-results');
		if (!list) return;

		if (form === clickedForm) {
			if (target === form.querySelector('input[type="search"]') && list.innerHTML !== '') {
				list.style.display = 'block';
			}
		} else {
			list.style.display = 'none';
		}
	});
});
// header search modal
var modals = document.querySelectorAll(".js-search-modal");

function closeSearchModal(modal, modalHeight) {
	document.body.classList.remove('show-search-modal');
	var tl = gsap.timeline();
	tl.to(modal, {
		duration: 0.2,
		top: modalHeight
	}).to(modal, {
		duration: 0.1,
		display: "none"
	});
}

modals.forEach(function(modal) {
	var modalHeight = '-134px';
	var headerNav = modal.closest('.header-search-nav');
	var btn = headerNav ? headerNav.querySelector(".js-search-modal-link") : null;
	var close = modal.querySelector(".search-modal-close");

	if (btn) {
		btn.onclick = function() {
			gsap.set(modal, {
				display: "block",
				top: modalHeight
			});
			gsap.to(modal, {
				duration: 0.1,
				top: '0'
			});
			document.body.classList.add('show-search-modal');
		};
	}
	if (close) {
		close.onclick = function() {
			closeSearchModal(modal, modalHeight);
		};
	}
});

window.addEventListener('click', function(event) {
	modals.forEach(function(modal) {
		if (event.target === modal) {
			closeSearchModal(modal, '-134px');
		}
	});
});
